/* istanbul ignore file */

export function bytesForHuman(bytes) {
  if (!bytes) {
    return '';
  }
  let num = bytes;
  const units = ['', 'K', 'M', 'B', 'T', 'P'];

  let i = 0;

  for (i; num > 1000; i += 1) {
    num /= 1000;
  }

  return `${num.toFixed(1)} ${units[i]}`;
}
